import React, { useEffect, useState } from 'react';
import { app } from "app/app";
import 'assets/sass/download-app/DownloadApp.scss';
import { images } from "assets/img/common/common";
import useUserAgent from "../hooks/useUserAgent";

const DownloadAppPage = () => {
    const { isMobile } = useUserAgent();

    const goToDownloadApp = () => {
        window.location = 'https://buenbit.onelink.me/A1PW/55a3c7e9';
    };

    return (
        <div className="download-app-landing">
            <div className={`download-app-container ${!isMobile && 'desktop'}`}>
                <img className="download-app-logo" src={images.logo} alt={app.productName()}/>
                <div className="download-app-container-box">
                    {
                        isMobile
                            ?   (
                                <>
                                    <p>Para continuar descarga la APP</p>
                                    <div className="download-app-button">
                                        <button className={`cta-button`} onClick={() => goToDownloadApp()}>
                                            Descargar
                                        </button>
                                    </div>
                                </>
                            )
                            :   (
                                <>
                                    <p>Escanea el código QR para continuar desde la app de Buenbit</p>
                                    <div className="download-app-qr">
                                        <img src={images.qrStores} alt={app.productName()}/>
                                    </div>
                                </>
                            )
                    }
                </div>
            </div>
        </div>
    );
};

export default DownloadAppPage;

